/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  openBatchesList         : [],
  batchStatesList         : [],
  myHoldList              : [],
  mySupReviewList         : [],
  incident                : {},
  incidentClaims          : [],
  incidentSupplements     : []
}

export default state
